import { ActivityCategory, ActivityEventType } from '@repo/types';

export enum DiffType {
  ADDED = 'added',
  UPDATED = 'updated',
  DELETED = 'deleted',
}

/**
 * Represents a single field change in the diff.
 * The `type` indicates whether the field was added, updated, or deleted.
 */
export interface ActivityChange<T = unknown> {
  type: DiffType;
  old: T;
  new: T;
}

/**
 * Recursive diff structure - can contain direct changes or nested objects.
 * Example:
 * {
 *   "appeal": {
 *     "remainingAmount": { "type": "added", "new": 211.88, "old": null }
 *   },
 *   "appealStatus": { "type": "updated", "new": "TO_BE_APPEALED", "old": "PRE_APPEAL" }
 * }
 */
export type ActivityDiff = {
  [key: string]: ActivityChange | ActivityDiff;
};

export interface Activity {
  activityLogId?: string;
  eventId?: string;
  category: ActivityCategory;
  eventType: ActivityEventType;
  actorId?: string;
  actorName: string;
  actorRole?: string;
  createdAt: number;
  diff?: ActivityDiff;
}

/**
 * Hierarchical diff node for tree-like display.
 * Each node represents either a change (leaf) or a group of changes (branch).
 */
export interface DiffNode {
  /** The field name/key */
  key: string;
  /** If this is a leaf node (actual change), contains the change details */
  change?: ActivityChange;
  /** If this is a branch node (nested object), contains child nodes */
  children?: DiffNode[];
}
